/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable react/jsx-boolean-value */
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Grid, Paper } from '@mui/material';
import './Formula.css';
import Table from './Table/index';
import Typography from '../../../components/atoms/Typography/index';
import FileUpload from '../../../components/molecules/FileUpload/index';
import DatePicker from '../../../components/atoms/DatePicker';
import {
  GET_FORMULA_CONFIG,
  INSERT_FORMULA_CONFIG,
  GET_MASTER_TEMPLATES,
  FORMULA_APPROVAL_ATTACHMENT,
} from '../../../constants/actionType';
/**
 * @returns {React.ReactElement} return the user role component
 */
const FormulaConfiguration = () => {
  const [date, setDate] = React.useState(new Date());
  const dispatch = useDispatch();
  const [file, setFile] = useState();
  const [approveNote, setApproveNote] = useState({});
  const { getMasterTemplate } = useSelector((state) => state.masterTemplate);
  const InputActionValidation = localStorage.getItem('ActionAccess');
  const Actionvalue = JSON.parse(InputActionValidation);
  const { BulkUpload, Download, Edit, ManualDataInput, View } = Actionvalue?.masters?.[0];
  console.log(BulkUpload, Download, Edit, ManualDataInput, View, 'aslkdjqqfasoihr');

  useEffect(() => {
    dispatch({ type: GET_MASTER_TEMPLATES });
  }, [dispatch]);
  /**
   * @param {*} files - sending files
   */
  const sendSelectedFiles = (files) => {
    setFile(files);
  };
  /**
   * @param {object} obj - sending object
   */
  const sendApprovalAttachment = (obj) => {
    setApproveNote(obj);
  };
  /**
   *
   */
  const onSubmitFiles = async () => {
    await dispatch({ type: INSERT_FORMULA_CONFIG, payload: file });
    await dispatch({ type: FORMULA_APPROVAL_ATTACHMENT, payload: approveNote });
    dispatch({ type: GET_FORMULA_CONFIG });
  };

  return (
    <Grid container item md={12} spacing={3} sx={{ paddingTop: 2 }} className="dataLayout">
      <Grid item md={BulkUpload === 1 ? 9 : 12} sm={12} xs={12} className="noPadding">
        <Paper elevation={3} className="splitPage">
          <Grid>{View === 1 && <Table />}</Grid>
          <Grid sx={{ p: 3 }} item container direction="column">
            <Typography
              text="This screen shall be used only for the Backend Configuration reference only"
              colorType="senary"
              type="link"
              customClass="footText"
            />
            <Typography
              text="Business User has to convey threshold values to the technical team using the 'Threshold Configuration Attachment' "
              colorType="senary"
              type="link"
              customClass="footText"
            />
            <Typography
              text="At one Point of time,Only one Record shall be active."
              colorType="senary"
              type="link"
              customClass="footText"
            />
            <Typography
              text="On Bulk Upload Previous Active Record will be deactivated"
              colorType="senary"
              type="link"
              customClass="footText"
            />
          </Grid>
        </Paper>
      </Grid>

      {BulkUpload === 1 && (
        <Grid item md={3} sm={12} xs={12} sx={{ height: '100%' }} className="paddingView">
          <Paper elevation={3} className="splitPage">
            <Grid>
              <Grid>
                <FileUpload
                  bulkUploader
                  wordUploader
                  templateUrl={getMasterTemplate.formulaConfiguration}
                  excelUploader
                  downloadTemplate
                  sendSelectedFile={(files) => sendSelectedFiles(files)}
                  sendAttachment={(obj) => sendApprovalAttachment(obj)}
                  onSubmitFiles={() => onSubmitFiles()}
                  masterSetup
                  isSubmit={true}
                />
              </Grid>

              <Grid sx={{ pt: 4 }}>
                <DatePicker calendarPicker date={date} onHandleChange={(newDate) => setDate(newDate)} />
              </Grid>
            </Grid>
          </Paper>
        </Grid>
      )}
    </Grid>
  );
};
export default FormulaConfiguration;
